import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import { startCase } from 'lodash'
import {
  LIVE_WINS_TABS,
  LIVE_WINS_TYPES,
  LOADER_HANDLER_TYPES
} from 'constants/index'
import { getLiveTransactions } from 'redux-thunk/thunk/casino.thunk'
import Loader from 'components/ui-kit/Loader/index'
import { RedLiveCircleIcon } from 'components/ui-kit/Icons/svg/index'

const LiveWins = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [selectedTab, setSelectedTab] = useState(LIVE_WINS_TABS.MONTH)
  const { liveData, liveTransactionsData } = useSelector(
    (state) => state.casino
  )
  const { [LOADER_HANDLER_TYPES.liveWins]: loading } = useSelector(
    (state) => state.loader
  )
  const limit = 20
  const handleTabChange = (e, tab) => {
    e.preventDefault()
    setSelectedTab(tab)
  }

  useEffect(() => {
    if (selectedTab !== LIVE_WINS_TABS.LIVE_WINS) {
      dispatch(getLiveTransactions({ limit, dateOptions: selectedTab }))
    }
  }, [selectedTab])

  return (
    <section className='live-wins'>
      <div className='inner-heading mb-2'>
        <RedLiveCircleIcon />
        <h4
          className={`text-uppercase live-wins-heading ${
            selectedTab === LIVE_WINS_TABS.LIVE_WINS ? '' : 'text-muted'
          }`}
          onClick={(e) => handleTabChange(e, LIVE_WINS_TABS.LIVE_WINS)}
          type='button'
        >
          {t('liveWins')}
        </h4>
        <div className='week-wrap d-flex align-items-center ms-2'>
          <NavLink
            to=''
            onClick={(e) => handleTabChange(e, LIVE_WINS_TABS.MONTH)}
            className={`${
              selectedTab === LIVE_WINS_TABS.MONTH ? 'active' : 'text-muted'
            }`}
          >
            {t('monthlyStatus')}
          </NavLink>
          <NavLink
            to=''
            onClick={(e) => handleTabChange(e, LIVE_WINS_TABS.WEEK)}
            className={`${
              selectedTab === LIVE_WINS_TABS.WEEK ? 'active' : 'text-muted'
            }`}
          >
            {t('weeklyStatus')}
          </NavLink>
          <NavLink
            to=''
            onClick={(e) => handleTabChange(e, LIVE_WINS_TABS.DAY)}
            className={`${
              selectedTab === LIVE_WINS_TABS.DAY ? 'active' : 'text-muted'
            }`}
          >
            {t('dailyStatus')}
          </NavLink>
        </div>
      </div>
      <div className='theme-card-wrap'>
        <div className='theme-card'>
          <div
            className={`live-card-wrap d-flex align-items-center ${
              loading ? 'justify-content-center' : ''
            }`}
          >
            {selectedTab === LIVE_WINS_TABS.LIVE_WINS &&
              liveData
                ?.filter(
                  (data) =>
                    data?.data?.type === LIVE_WINS_TYPES.CASINO_WIN &&
                    data?.data?.amount !== 0
                )
                ?.map((data) => (
                  <div key={data?.data?.id} className='live-card'>
                    <div className='live-img'>
                      <img src={data?.data?.image} alt='Live' />
                    </div>
                    <p>{data?.data?.user?.userName}</p>
                    <span>${data?.data?.amount}</span>
                  </div>
                ))}

            {selectedTab !== LIVE_WINS_TABS.LIVE_WINS &&
              (loading
                ? (
                  <Loader variant={LOADER_HANDLER_TYPES.liveWins} />
                  )
                : (
                    liveTransactionsData?.rows?.map((data) => (
                      <div key={uuidv4()} className='live-card'>
                        <div className='live-img'>
                          <img src={data?.casino?.image} alt='Live' />
                        </div>
                        <p>{startCase(data?.user?.userName)}</p>
                        <span>${data?.amount}</span>
                      </div>
                    ))
                  ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default React.memo(LiveWins)
